module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list', {
    attrs: {
      "mode": "swipeUp"
    },
    on: {
      "on-loading": _vm.loading
    }
  }, _vm._l((_vm.datas), function(item) {
    return _c('li', {
      staticClass: "list-item list-item-arrow m1111"
    }, [_c('div', {
      staticClass: "card p2222"
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('p', [_vm._v("\n          " + _vm._s(item.content) + "\n        ")])])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20267eae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/demo3.vue
// module id = 233
// module chunks = 13